const injectDeleteButtonStyles = () => {
    const deleteButtonStyleId = 'impowerx-delete-button-styles'
    if (document.getElementById(deleteButtonStyleId)) return

    const deleteButtonStyle = document.createElement('style')
    deleteButtonStyle.id = deleteButtonStyleId
    deleteButtonStyle.textContent = `
      .delete-button:disabled {
        cursor: not-allowed !important;
        pointer-events: none !important;
        .anticon svg path {
          fill: #777777 !important;
        }
        .anticon svg {
          fill: #777777 !important;
        }
      }
    `
    document.head.appendChild(deleteButtonStyle)
}

const injectFileInputStyles = () => {
    const fileInputStyleId = 'impowerx-file-input-styles'
    if (document.getElementById(fileInputStyleId)) return

    const fileInputStyle = document.createElement('style')
    fileInputStyle.id = fileInputStyleId
    fileInputStyle.textContent = `
      .impower-x-file-input:disabled,
      .impower-x-file-input[disabled],
      .file-input-label:disabled,
      .file-input-label[disabled],
      .impower-x:disabled,
      .impower-x[disabled] {
        color: #777777 !important;
        cursor: not-allowed !important;
        pointer-events: none !important;
        .anticon svg path {
          fill: #777777 !important;
        }
        .anticon svg {
          fill: #777777 !important;
        }
        .Button.ant-btn {
          color: #777777 !important;
        }
      }
    `
    document.head.appendChild(fileInputStyle)
}

const injectDropdownMenuStyles = () => {
    const dropdownMenuStyleId = 'impowerx-dropdown-menu-styles'
    if (document.getElementById(dropdownMenuStyleId)) return

    const dropdownMenuStyle = document.createElement('style')
    dropdownMenuStyle.id = dropdownMenuStyleId
    dropdownMenuStyle.textContent = `
      .impowerx-select-menu-item{
        padding: 0.7rem;
        margin: 0;
        &:hover {
          background: #f5f5f5 !important;
        }
      }
    `
    document.head.appendChild(dropdownMenuStyle)
}

const injectImpowerXStyles = () => {
    injectFileInputStyles()
    injectDeleteButtonStyles()
    injectDropdownMenuStyles()
}

